import type { AppRouteModule } from '/@/router/types';
import { t } from '/@/hooks/web/useI18n';

import { titleToolMap, routeToolMap } from '/@/enums/editor/index';
import { isEmpty } from '/@/utils/is';

const editor: AppRouteModule = {
  path: '/creation',
  name: 'Creation',
  component: () => import('/@/layouts/editor/index.vue'),
  redirect: '/creation',
  meta: {
    hideChildrenInMenu: true,
    orderNo: 3,
    icon: 'icon-huihua',
    title: t('routes.create.recreate'),
  },
  children: [
    {
      path: '/editor/:id/:ability?',
      name: 'EditorView',
      component: () => import('/@/views/edit/index.vue'),
      meta: {
        metaInfo: (route) => {
          const ability = routeToolMap[route.params.ability];
          return {
            title: titleToolMap[ability],
          };
        },
      },
      props(route) {
        return {
          id: route.params.id,
          ability: routeToolMap[route.params.ability],
        };
      },
    },
    {
      path: '/common-editor/:id/:ability?',
      name: 'CommonEditor',
      component: () => import('/@/views/common-editor/index.vue'),
      meta: {
        // metaInfo: (route) => {
        //   const ability = routeToolMap[route.params.ability];
        //   return {
        //     title: titleToolMap[ability],
        //   };
        // },
      },
      // props(route) {
      //   return {
      //     id: route.params.id,
      //     ability: routeToolMap[route.params.ability],
      //   };
      // },
    },
    {
      path: '/canvas/:designId?',
      name: 'Photoshop',
      component: () => import('/@/views/photoshop/index.vue'),
      meta: {
        title: '智绘画布',
      },
      beforeEnter: async (to, _, next) => {
        if (isEmpty(to.query) && !to.params.designId) {
          next('/creation');
        } else {
          next();
        }
      },
    },
    {
      path: '/download',
      name: 'DownloadPage',
      component: () => import('/@/views/edit/downloadPage/index.vue'),
      meta: {
        title: '下载作品',
      },
      props(route) {
        return {
          url: route.query.url,
        };
      },
    },
    {
      path: '/pod',
      name: 'POD',
      meta: {
        title: 'pod',
      },
      component: () => import('/@/views/pod/index.vue'),
    },
    {
      path: '/pod/excel',
      name: 'PODExcel',
      meta: {
        title: '导出excel',
      },
      component: () => import('/@/views/pod/excel.vue'),
    },
  ],
};

export default editor;
